var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.42412 10.7575C8.1898 10.9918 7.8099 10.9918 7.57559 10.7575L3.57559 6.75749C3.34128 6.52318 3.34128 6.14328 3.57559 5.90896C3.8099 5.67465 4.1898 5.67465 4.42412 5.90896L7.99985 9.4847L11.5756 5.90896C11.8099 5.67465 12.1898 5.67465 12.4241 5.90896C12.6584 6.14328 12.6584 6.52318 12.4241 6.75749L8.42412 10.7575Z",
    fill: "#9D9D9D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/DownArrow.3faa27df4084769fc139515125600143.svg";
export { ForwardRef as ReactComponent };